module.exports = __webpack_public_path__ + "img/OBCINA BOHINJ.1a5589e3.png";